import React, { useState, useContext, useEffect } from 'react'
// import PropTypes from 'prop-types'
import { Equalizer, Map, Settings } from '@material-ui/icons'
import { getQueryStringValue } from '../PropertySearch/Utility/Utility'
import searchContext from '../PropertySearch/FiltersComponent/context/context'
import getListDetails from '../PropertyList/Utility/GetListDetails/GetListDetails'
import SidebarMenu from '../PropertySearch/Sidebar/SidebarMenu/SidebarMenu'
import HeadBar from './HeadBar/HeadBar'
import MapComponent from '../PropertySearch/MapComponent/MapComponent'
import CompsPage from '../PropertyList/CompsPage/CompsPage'
import PropertyListSettings from '../PropertyList/PropertyListSettings/PropertyListSettings'
import { ContextProvider } from '../Common/context/context'
// import getSavedSearch from '../PropertySearch/Utility/GetSavedSearch/GetSavedSearch'

const PropertyList = () => {

    const [selectedTab, setSelectedTab] = useState('comp')
    const [isOnLoad, setIsOnLoad] = useState(true)
    const [propertyList, setPropertyList] = useState()
    const [propertyListId, setPropertyListId] = useState({})
    const { setShowSpinner } = useContext(searchContext)
    const [focusedMode, setFocusedMode] = useState(false)
    // const [refreshList, setRefreshList] = useState(true)
    // const [setSavedSearchLoading] = useState(true)

    const handleTabChange = newTab => {
        setSelectedTab(newTab)
    }

    // useEffect(() => {
    //     fetchListDetails(false)
    //     if (propertyListId && Object.keys(propertyListId).length !== 0)
    //         fetchListDetailsAfterDML()
    // }, [propertyListId])

    useEffect(() => {
        fetchListDetails(false)
    }, [propertyListId])

    useEffect(() => {
        if (isOnLoad) {
            setShowSpinner(true)
            setIsOnLoad(false)
            const list_id = getQueryStringValue('list_id')
            const list_ov_id = getQueryStringValue('list_ov_id')

            setPropertyListId({
                polarisPropertySearchCriteriaId: list_id,
                omniViewPropertyListId: list_ov_id
            })
            // fetchListDetailsAfterDML()
        }
    }, [isOnLoad])

    // const init = () => {
    //     fetchListDetails()
    // }

    async function fetchListDetailsAfterDML() {
        let count = 1
        do {
            await new Promise(resolve => setTimeout(resolve, 5000));
            let pathname = window.location.pathname
            pathname = pathname.toLowerCase()
            if (pathname.includes('propertylist') && propertyListId) {
                const getListDetailsObj = new getListDetails(propertyListId, setPropertyList, setShowSpinner, false)
                await getListDetailsObj.fetchResult()
            }
            count++;
        } while (count < 3);
    }


    const fetchListDetails = async (reloadFlag = true) => {
        if (propertyListId.polarisPropertySearchCriteriaId || propertyListId.omniViewPropertyListId) {
            const getListDetailsObj = new getListDetails(propertyListId, setPropertyList, setShowSpinner, reloadFlag)
            await getListDetailsObj.fetchResult()
            fetchListDetailsAfterDML()
        }
    }

    const getMapsPropertyList = () => {
        let mapsPropertyList = []

        if (propertyList && propertyList.compsList) {
            propertyList.compsList.forEach(item => {
                let omniviewproperty = item.data.omniviewproperty[0]
                omniviewproperty.isSubjectProperty = item.isSubjectProperty
                omniviewproperty.propertyLocation = item.data.propertyLocation
                mapsPropertyList.push(omniviewproperty)
            })
        }

        return mapsPropertyList
    }

    const getCompType = () => {
        let compType = 'Rent'

        if (propertyList && propertyList.compType) {
            compType = propertyList.compType
        }

        return compType
    }

    const getPropertyListName = () => {
        let name = ''

        if (propertyList && propertyList.name) {
            name = propertyList.name
        }

        return name
    }

    return (
        <>
            <ContextProvider value={{ fetchListDetails, setPropertyListId, propertyList, setPropertyList, propertyListId, focusedMode, setFocusedMode }}>
                <header style={{ height: 56 }} className="text-white col-span-3 theme-dark overflow-hidden sticky-top z-sticky">
                    <HeadBar listName={getPropertyListName()}></HeadBar>
                </header>
                <div className="w-full flex flex-row">
                    {!focusedMode && <div style={{ 'zIndex': '1 !important', 'top': '56px' }} className="h-screen-75 p-2 sticky-top">
                        <SidebarMenu ></SidebarMenu>
                    </div>}
                    <div className="w-full bg-white">
                        {!focusedMode &&
                            <nav className="border-b-1 border-base flex flex-row text-2">
                                <button data-testid="test-btn-show-list-overView" onClick={() => handleTabChange('comp')} className={`btn px-6 capitalize ${selectedTab === 'comp' ? 'text-primary bg-gray-15 border-b-1 border-l-0 border-r-0 border-t-0 border-primary' : 'bg-white'} `}>
                                    <span className="pr-2"> <Equalizer fontSize="small"></Equalizer> </span>
                                    {`${getCompType()} Comp`}
                                </button>
                                <button data-testid="test-btn-show-list-map" onClick={() => handleTabChange('map')} className={`btn px-6 ${selectedTab === 'map' ? 'text-primary bg-gray-15 border-b-1 border-l-0 border-r-0 border-t-0 border-primary' : 'bg-white'} `}>
                                    <span className="pr-2"> <Map fontSize="small"></Map> </span>
                                    Map
                                </button>
                                <button data-testid="test-btn-show-list-setting" onClick={() => handleTabChange('settings')} className={`btn px-6 ${selectedTab === 'settings' ? 'text-primary bg-gray-15 border-b-1 border-l-0 border-r-0 border-t-0 border-primary' : 'bg-white'} `}>
                                    <span className="pr-2"> <Settings fontSize="small"></Settings> </span>
                                    Settings
                                </button>
                            </nav>}
                        {selectedTab === 'comp' && <div data-testid="test-div-show-list-overView" className="w-full pt-4 bg-gray-10 h-full mb-10">
                            <CompsPage />
                        </div>}
                        {selectedTab === 'map' && <div data-testid="test-div-show-list-map" className="w-full h-screen-75">
                            <MapComponent fullHeight={true} propertyList={getMapsPropertyList()} showCluster={false} isList={true} />
                        </div>}
                        {selectedTab === 'settings' && <div data-testid="test-div-show-list-setting" className="w-full">
                            <PropertyListSettings />
                        </div>}
                    </div>
                </div>
            </ContextProvider>
        </>
    )
}

// PropertyList.propTypes = {
//     listId: PropTypes.string
// }

export default PropertyList
